<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="EOTPREMNICA.SINGULAR"></span></h2>
    <h1 class="modal-title">
      <span>Stavka</span>
    </h1>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <yt-eotpremnica-stavka-update #baseUpdate></yt-eotpremnica-stavka-update>
</div>
<!-- <div class="modal-footer" *ngIf="this.modelData.MainList.FormControlDataName == 'eotpremnice/izeotpremnicastavka'">
  <button type="submit" class="btn btn-primary" (click)="Save()"><span>Sačuvaj</span></button>
  <button type="button" class="btn btn-secondary" (click)="Close()"><span>Zatvori</span></button>
</div> -->